import { linePlot, numberInput, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { smaAt } from "../math/movingAverages";
import { standardDeviationAt } from "../math/statistics";

/**
 * Bollinger Bands Width (research §1.4), as TV Bollinger Bands Width: the
 * distance between the bands of Bollinger Bands over their middle line.
 */
export default {
  id: "bollinger-bands-width",
  name: "Bollinger Bands Width",
  isOscillator: true,
  decimals: 4,
  inputs: [
    periodInput("period", "Period", 20, { min: 5, max: 250 }),
    numberInput("deviation", "Deviation", 2, { min: 1, max: 50, precision: 2 }),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.LIME),
  ],
  levels: [],

  calculate: (bars, { period, deviation }, series, fromIndex) => {
    const read = priceReader(bars, PRICE_SOURCE.CLOSE);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const middle = smaAt(read, index, period);
      const width = deviation * standardDeviationAt(read, index, period);

      // The same steps as TV, so the values match to the last digit
      series.value[index] = (middle + width - (middle - width)) / middle;
    }
  },
};
